import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Card, CardContent } from "@groot/ui/card";
import { Lock, Webhook, FileText, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const ICONS: Record<string, LucideIcon> = {
  unlock_pdf: Lock,
  webhook: Webhook,
};

export function ActionNode({ data, selected }: NodeProps) {
  const Icon = ICONS[data.actionType as string] || FileText;

  return (
    <div className={cn("w-64", selected && "ring-2 ring-primary rounded-lg")}>
      <Handle type="target" position={Position.Top} className="w-3 h-3 bg-primary" />
      <Card>
        <CardContent className="p-4 flex items-center gap-3">
          <div className="size-10 rounded-full bg-secondary flex items-center justify-center text-secondary-foreground">
            <Icon size={20} />
          </div>
          <div>
            <div className="font-medium text-sm capitalize">
              {(data.label as string) || "Action"}
            </div>
            <div className="text-xs text-muted-foreground truncate max-w-[140px]">
              {(data.description as string) || "Configure action"}
            </div>
          </div>
        </CardContent>
      </Card>
      <Handle type="source" position={Position.Bottom} className="w-3 h-3 bg-primary" />
    </div>
  );
}
